"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNewebPaySingleTradeQueryRequest = instanceOfNewebPaySingleTradeQueryRequest;
exports.NewebPaySingleTradeQueryRequestFromJSON = NewebPaySingleTradeQueryRequestFromJSON;
exports.NewebPaySingleTradeQueryRequestFromJSONTyped = NewebPaySingleTradeQueryRequestFromJSONTyped;
exports.NewebPaySingleTradeQueryRequestToJSON = NewebPaySingleTradeQueryRequestToJSON;
exports.NewebPaySingleTradeQueryRequestToJSONTyped = NewebPaySingleTradeQueryRequestToJSONTyped;
/**
 * Check if a given object implements the NewebPaySingleTradeQueryRequest interface.
 */
function instanceOfNewebPaySingleTradeQueryRequest(value) {
    if (!('merchantOrderNo' in value) || value['merchantOrderNo'] === undefined)
        return false;
    return true;
}
function NewebPaySingleTradeQueryRequestFromJSON(json) {
    return NewebPaySingleTradeQueryRequestFromJSONTyped(json, false);
}
function NewebPaySingleTradeQueryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'merchantOrderNo': json['merchantOrderNo'],
        'amt': json['amt'] == null ? undefined : json['amt'],
    };
}
function NewebPaySingleTradeQueryRequestToJSON(json) {
    return NewebPaySingleTradeQueryRequestToJSONTyped(json, false);
}
function NewebPaySingleTradeQueryRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'merchantOrderNo': value['merchantOrderNo'],
        'amt': value['amt'],
    };
}
